import $ from 'jquery';

const init = () => {

  // wrap any tables that don't have another class in a ".table-responsive" wrapper div by default
  // see: http://adrianroselli.com/2017/11/a-responsive-accessible-table.html#Responsive

  $('table:not([class])').each((index, el) => {
    let $this = $(el);
    let tableID = `responsive-table-${index}`;
    $this.find('caption').attr('ID', tableID);
    $this.wrap(`<div role="region" aria-labelledBy="${tableID}" tabindex="0" class="table-responsive"></div>`);
  });

};

export {
  init
}